import { getFunctions, httpsCallable, Functions } from 'firebase/functions';
import { app } from '@/lib/firebase';

let functionsInstance: Functions | null = null;

function getFunctionsInstance(): Functions {
  if (!functionsInstance) {
    functionsInstance = getFunctions(app);
  }
  return functionsInstance;
}

export type MigrateNotificationActionUrlsRequest = {
  dryRun?: boolean;
  pageSize?: number;
  startAfterId?: string;
  includeMissingActionUrl?: boolean;
};

export type MigrateNotificationActionUrlsResult = {
  dryRun: boolean;
  processed: number;
  updated: number;
  pageSize: number;
  nextPageToken: string | null;
  samples: Array<{ id: string; type?: string; userId?: string; from?: string; to?: string }>;
};

export type PurgeUserCompletelyRequest = {
  userId?: string;
  email?: string;
  confirmText: string;
};

export type PurgeUserCompletelyResult = {
  ok: boolean;
  targetUid: string;
  deletedDocs: number;
  deletedStorageFiles: number;
  deletedAuthUser: boolean;
  warnings: string[];
};

export type VerifyUserPurgeResidueRequest = {
  userId?: string;
  email?: string;
};

export type VerifyUserPurgeResidueResult = {
  ok: boolean;
  targetUid: string;
  authUserExists: boolean;
  firestoreMatches: Array<{ collection: string; field: string; count: number; sampleDocPaths: string[] }>;
  storageMatches: Array<{ prefix: string; count: number; sampleFilePaths: string[] }>;
  totalFirestoreMatches: number;
  totalStorageFiles: number;
  warnings: string[];
};

export async function migrateNotificationActionUrls(
  payload: MigrateNotificationActionUrlsRequest
): Promise<MigrateNotificationActionUrlsResult> {
  const fn = httpsCallable(getFunctionsInstance(), 'migrateNotificationActionUrls');
  const result = await fn(payload);
  return result.data as MigrateNotificationActionUrlsResult;
}

export async function purgeUserCompletely(
  payload: PurgeUserCompletelyRequest
): Promise<PurgeUserCompletelyResult> {
  const fn = httpsCallable(getFunctionsInstance(), 'purgeUserCompletely');
  const result = await fn(payload);
  return result.data as PurgeUserCompletelyResult;
}

export async function verifyUserPurgeResidue(
  payload: VerifyUserPurgeResidueRequest
): Promise<VerifyUserPurgeResidueResult> {
  const fn = httpsCallable(getFunctionsInstance(), 'verifyUserPurgeResidue');
  const result = await fn(payload);
  return result.data as VerifyUserPurgeResidueResult;
}
